import { ActionTypes, ConditionTypes, Triggers } from 'automations/types/automationConfig';

export enum NodeType {
  newBlock = 'newBlock',
  fallback = 'fallback',
  trigger = 'trigger',
  action = 'action',
  condition = 'condition',
}

export const combinedSubNodes = [
  ...Object.values(ConditionTypes),
  ...Object.values(ActionTypes),
  ...Object.values(Triggers),
];
